module.exports = __webpack_public_path__ + "media/images/banner-for-all-928d8936401315f0d7d2607601a063c6.webp";